import styled from "styled-components"
import TermsItem from "./TermsItem"
import { useNavigate } from "react-router-dom"

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`
const TermsList = ({ datas, terms, onItemCheck }) => {
  const navigate = useNavigate();
  return (
    <Container>
      {datas
        .filter(data => data.status !== 'all') 
        .map((data) => (
        <TermsItem
          key={data.id}
          label={data.label}
          checked={terms.has(data.id)}
          onChange={(checked) => onItemCheck(data.id, checked)}
          onOpen={() => navigate(`/signup/terms/${data.file}`)}/>
      ))}
    </Container>
  )
}

export default TermsList
